import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/reset.css'

Vue.config.productionTip = false

const setH5Rem = () => {
  const docEl = document.documentElement
  const width = docEl.clientWidth
  const isH5 = width <= 768
  if (!isH5) {
    docEl.style.fontSize = ''
    return
  }

  const cappedWidth = Math.min(width, 750)
  docEl.style.fontSize = `${(cappedWidth / 750) * 100}px`
}

setH5Rem()
window.addEventListener('resize', setH5Rem, { passive: true })
window.addEventListener('orientationchange', setH5Rem, { passive: true })

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
